module.exports = __webpack_public_path__ + "img/btn.a5fe398c.webp";